import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'projects/chat-common/src/lib/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'chatapp';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    const accessCode = this.route.snapshot.queryParamMap.get('accessCode');
    // Report pages are opened with an accessCode and should stay where they are after sign-in
    const isReportPage = window.location.pathname.startsWith('/report/');
    if (accessCode) {
      this.authService.signWithRefreshToken(accessCode).subscribe({
        next: () => {
          // Remove accessCode from URL and navigate to protected area
          this.router.navigate([], {
            queryParams: { accessCode: null },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          }).then(() => {
            // Navigate to health-assistant after successful auth
            if (!isReportPage) {
              this.router.navigate(['/health-assistant']);
            }
          });
        },
        error: (err) => {
          console.error('Authorization with accessCode failed', err);
        }
      });
    }
  }
}
